import React from 'react';
import Button from '../../components/button/button_v2';

import logopluga from '../../assets/logos/pluga.png';
import iconCopy from '../../assets/icons/icons8-copiar-32-branco.png';
import { JsonReceita, JsonProdutor, JsonCancelamento, JsonReceitaNativa, JsonProdutorNativa } from './codes';
import {
    CodeCard, CodeCardHeader, CodeGrid, CopyButton, ManualContainer, Pre, RequisitosList, Section, SectionTag, Text, Title
} from './styles';

const CodeBlock = ({ label, isPluga, json }) => (
    <CodeCard>
        <CodeCardHeader>
            <span>
                {isPluga ? (<img src={logopluga} width='48px' alt='Logo Pluga' />) : label}
            </span>
            <CopyButton onClick={() => navigator.clipboard.writeText(json)}>
                <img src={iconCopy} alt='Copiar código' />
                Copiar
            </CopyButton>
        </CodeCardHeader>
        <Pre>{json}</Pre>
    </CodeCard>
);

const Manual = ({ ...props }) => {

    return (
        <ManualContainer>
            <Section>
                <Title>Como preencher os dados para integração</Title>
                <Text>Na tela anterior, clique no botão <b>CRIAR INTEGRAÇÃO</b>.</Text>
                <Text>Na próxima tela, primeiramente selecione qual função do AgroReceita deseja integrar com o seu sistema ERP:</Text>

                <RequisitosList>
                    <li><b>Emissão de Receita:</b> enviará para o link todas as informações do receituário agronômico após a emissão.</li>
                    <li><b>Cancelamento de Receita:</b> enviará para o link todas as informações do receituário agronômico cancelado.</li>
                    <li><b>Cadastro de Fazenda:</b> enviará os dados do produtor e da fazenda cadastrada no AgroReceita para o link informado.</li>
                </RequisitosList>

                <Text><b>URL:</b> neste campo deverá ser digitado o link passado pelo sistema de ERP onde serão enviados os dados do JSON.</Text>
                <Text><b>Header:</b> neste campo deverá ser digitado os dados do header passados pelo sistema ERP com o tipo do Header e seu valor para o envio dos dados do JSON.</Text>
            </Section>

            <Section>
                <Title>Observações e requisitos</Title>
                <RequisitosList>
                    <li>Possuir a URL do outro sistema, que vai receber dados em formato JSON.</li>
                    <li>Em caso de URLs personalizadas, é importante ter um desenvolvedor ou contato com o suporte do seu outro sistema para checar a compatibilidade com a leitura do pacote de dados que o AgroReceita envia.</li>
                </RequisitosList>
            </Section>

            <Section>
                <SectionTag>Função: Emissão de Receita</SectionTag>
                <Text>Os dados serão enviados seguindo a estrutura abaixo, que é a de um JSON padrão. Receitas emitidas com mais de um produto não serão enviadas via Pluga.</Text>

                <CodeGrid>
                    <CodeBlock label="Integração via Pluga" isPluga json={JsonReceita} />
                    <CodeBlock label="Integração nativa AgroReceita" json={JsonReceitaNativa} />
                </CodeGrid>
            </Section>

            <Section>
                <SectionTag>Função: Cancelamento de Receita</SectionTag>
                <Text>Os dados serão enviados seguindo a estrutura abaixo, que é a de um JSON padrão.</Text>

                <CodeGrid>
                    <CodeBlock label="Integração nativa AgroReceita" json={JsonCancelamento} />
                </CodeGrid>
            </Section>

            <Section>
                <SectionTag>Função: Cadastro de Fazenda</SectionTag>
                <Text>Os dados serão enviados seguindo a estrutura abaixo, que é a de um JSON padrão.</Text>

                <CodeGrid>
                    <CodeBlock label="Integração via Pluga" isPluga json={JsonProdutor} />
                    <CodeBlock label="Integração nativa AgroReceita" json={JsonProdutorNativa} />
                </CodeGrid>
            </Section>

            <Section style={{ alignItems: 'center' }}>
                <Text style={{ textAlign: 'center', marginTop: 0 }}>
                    Em caso de dúvidas entre em contato pelo e-mail <b>suporte@sudesteonline.com.br</b> ou pelo WhatsApp <b>(15) 98165.7739</b>.
                </Text>

                <div style={{ marginTop: '24px' }}>
                    <Button
                        width='296px'
                        height='50px'
                        value='SAIR'
                        outline={false}
                        disabled={false}
                        onClick={() => props.fechar()}
                    />
                </div>
            </Section>
        </ManualContainer>
    )
}

export default Manual;
